<template lang="pug">
v-fade-transition(mode="in-out" class="tw-p-0 tw-m-0")
  v-container(fluid fill-height class="tw-p-0 tw-h-screen tw-overflow-hidden")
    v-row(align="center" justify="space-between")
      v-col(cols="6" class="hidden-sm-and-down")
        v-card(tile :img="image" class="tw-h-screen tw-p-0 tw-m-0 tw-border-0")
      v-col(lg="6" cols="12")
        v-row(fill-height align="center" justify="center")
          v-col(lg="8" cols="10")
            v-row(align="center" justify="center")
              v-col(cols="auto")
                v-img(src="@/assets/images/kubiqa-logo.svg" width="300px")
            v-row(align="center" justify="center" class="tw-mt-8")
              v-col(class="text-center")
                div(class="tw-text-xl tw-font-bold tw-mb-2") {{ $t('Common.resetPasswordHeadline') }}
                div(class="tw-text-base tw-mb-5 tw-italic") {{ $t('Common.resetPasswordSubheadline') }}
                v-alert(v-if="!token" type="error" text role="alert" class="tw-mb-5")
                  | {{ $t('Common.passwordResetFailed') }}
                v-form(v-else ref="form" v-model="valid" lazy-validation @submit.prevent="submit" @keyup.native.enter="submit")
                  v-text-field(
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('Common.email')"
                    color="blue darken-4"
                    required
                    autocomplete="email"
                    type="email"
                  )
                  v-text-field(
                    v-model="password"
                    :rules="passwordRules"
                    :type="'password'"
                    :label="$t('Common.password')"
                    color="blue darken-4"
                    required
                    autocomplete="new-password"
                  )
                  v-text-field(
                    v-model="passwordConfirmation"
                    :rules="passwordConfirmationRules"
                    :type="'password'"
                    :label="$t('Common.passwordConfirmation')"
                    color="blue darken-4"
                    required
                    autocomplete="new-password"
                  )
                  v-btn(
                    type="submit"
                    color="rgba(94,129,244)"
                    elevation="0"
                    rounded
                    :loading="loading"
                    :disabled="loading"
                    class="tw-w-2/3"
                  )
                    span(class="tw-font-bold tw-uppercase") {{ $t('Common.resetPassword') }}
                v-row(align="center" justify="center" class="tw-mt-3")
                  router-link(:to="{ name: token ? 'ForgotPassword' : 'Login' }" class="tw-text-sm tw-font-medium tw-text-blue-700 tw-underline")
                    | {{ token ? $t('Common.requestAnotherResetLink') : $t('Common.login') }}
        v-snackbar(v-model="error" color="error") {{ error_message }}
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  name: 'ResetPassword',
  data() {
    const token = this.$route.query.token;
    const email = this.$route.query.email;

    return {
      valid: false,
      loading: false,
      error: false,
      error_message: '',
      token: typeof token === 'string' ? token : '',
      email: typeof email === 'string' ? email : '',
      password: '',
      passwordConfirmation: '',
      emailRules: [
        (value) => !!value || 'Please enter your email',
        (value) => !value || /^\S+@\S+\.\S+$/.test(value) || 'E-mail must be valid',
      ],
      passwordRules: [
        (value) => !!value || 'Please enter a password',
        (value) => !value || /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{16,}$/.test(value) || 'Min. 16 characters with uppercase, lowercase, number, and special character',
      ],
      image: require('@/assets/images/auth/real-estate-login.jpg'),
    };
  },
  computed: {
    passwordConfirmationRules() {
      return [
        (value) => !!value || 'Please confirm your password',
        (value) => value === this.password || 'Passwords must match',
      ];
    },
  },
  methods: {
    async submit() {
      if (this.loading || !this.token || !this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.error = false;

      try {
        await AuthService.resetPassword({
          token: this.token,
          email: this.email.trim(),
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        });
        await AuthService.login({ email: this.email.trim(), password: this.password });

        const user = await this.$store.dispatch('auth/getAuthUser');
        if (!user) {
          throw new Error('Unable to establish the account session after password reset.');
        }

        await this.$store.dispatch('auth/setGuest', { value: 'isNotGuest' });
        await this.$router.push('/dashboard');
      } catch (error) {
        const status = error.response && error.response.status;
        const errors = error.response && error.response.data && error.response.data.errors;
        this.error_message = errors && errors.password
          ? this.$t('Common.passwordResetValidationFailed')
          : status === 422 || status === 400
            ? this.$t('Common.passwordResetFailed')
            : this.$t('Common.resetLinkFailed');
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
